module.exports = __webpack_public_path__ + "static/img/page7_img4.e1d4a2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/page7_img4.jpg
// module id = Wp4y
// module chunks = 1